export default "__VITE_ASSET__CHcJjtRr__"